import type { NextPage } from 'next';
import styles from './footer-sidebar.module.scss';
import Image from 'next/image';
import Link from 'next/link';

export type FooterSidebarType = {
  className?: string;
};

const FooterSidebar: NextPage<FooterSidebarType> = ({ className = '' }) => {
  return (
    <div className={[styles.footersidebar, className].join(' ')}>
      <div className={styles.buttons}>
        <Link
          href="https://play.google.com/store/apps/details?id=com.heraflight.app"
          className={styles.buttongoogle}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            className={styles.vectorIcon1}
            width={253}
            height={43}
            sizes="100vw"
            alt=""
            src="/img/header/google.svg"
          />
        </Link>
        <Link
          href="https://apps.apple.com/us/app/hera-flight/id6749022937"
          className={styles.buttongoogle}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            className={styles.vectorIcon1}
            width={253}
            height={43}
            sizes="100vw"
            alt=""
            src="/img/header/apple.svg"
          />
        </Link>
      </div>
    </div>
  );
};

export default FooterSidebar;
